import { PSD2SessionStatusResponse } from '@/hooks/webapi/usePSD2Proxy';

type MapTypeToConst<T> = {
  [K in keyof T]: Record<T[K] extends string ? T[K] : never, Readonly<T[K]>>;
};

export const PSD2Statuses = {
  typeOfService: {
    IDENTIFICATION_PAYMENT: 'IDENTIFICATION_PAYMENT',
    TRANSACTION_HISTORY: 'TRANSACTION_HISTORY',
    PDF_PARSER: 'PDF_PARSER',
    ALL: 'ALL',
  },
  transactionHistory: {
    IN_PROGRESS: 'IN_PROGRESS',
    DOWNLOADED: 'DOWNLOADED',
    ERROR: 'ERROR',
    NAME_SURNAME_MISMATCH: 'NAME_SURNAME_MISMATCH',
    OUT_OF_RANGE: 'OUT_OF_RANGE',
    WRONG_STATEMENT_AMOUNT: 'WRONG_STATEMENT_AMOUNT',
    DONE: 'DONE',
  },
  paymentStatus: {
    DONE: 'DONE',
    ERROR: 'ERROR',
    INIT: 'INIT',
  },
  status: {
    NEW: 'NEW',
    IN_PROGRESS: 'IN_PROGRESS',
    EXPIRED: 'EXPIRED',
    ERROR: 'ERROR',
    DONE: 'DONE',
    INIT_ERROR: 'INIT_ERROR',
  },
} satisfies Readonly<MapTypeToConst<PSD2SessionStatusResponse>>;

export const PSD2ConsentType = {
  PSD2_DATA_PROCESSING: 'PSD2_DATA_PROCESSING',
  PSD2_DATA_PROCESSING_TRANSACTION_HISTORY:
    'PSD2_DATA_PROCESSING_TRANSACTION_HISTORY',
};

export const PHONE = '225 852 395';
export const PHONE_LINK = `+420${PHONE.replaceAll(' ', '')}`;

export const EMAIL = 'info@kimbi.cz';

export const VCC_LIVE_CHAT = {
  ACCOUNT_ID: '4fcz',
  PROJECT_ID: {
    AUTHENTICATED: 161,
    NON_AUTHENTICATED: 162,
    DEBTOR: 166,
  },
} as const;

export const TIME_WORKING_END_HOURS = '18:00';

// REGEX
export const EMAIL_REGEXP = /^[\w-]([.\w-])*@([\w-]+\.)+[A-Za-z]{2,6}$/;
